/**
 * アプリケーションルーティング定義
 */

import { Routes } from '@angular/router';
import { rootEntryRedirectGuard, workbenchModeAccessGuard } from './core/auth';

export const routes: Routes = [
  {
    path: '',
    pathMatch: 'full',
    canActivate: [rootEntryRedirectGuard],
    loadComponent: () =>
      import('./features/not-found/pages/not-found-page/not-found-page.component')
        .then(m => m.NotFoundPageComponent),
    title: 'ページが見つかりません',
  },
  {
    path: 'workbench',
    canActivate: [workbenchModeAccessGuard],
    loadComponent: () =>
      import('./features/workbench/pages/workbench-page/workbench-page.component')
        .then(m => m.WorkbenchPageComponent),
    title: 'ProSche - 入力補助',
    data: {
      mode: 'workbench',
    },
  },
  {
    path: 'inspection',
    loadComponent: () =>
      import('./features/workbench/pages/workbench-page/workbench-page.component')
        .then(m => m.WorkbenchPageComponent),
    title: 'ProSche - Inspection',
    data: {
      mode: 'inspection',
    },
  },
  {
    path: 'settings',
    loadComponent: () =>
      import('./features/settings/pages/settings-page/settings-page.component')
        .then(m => m.SettingsPageComponent),
    title: 'ProSche - 設定',
  },
  {
    path: 'not-found',
    loadComponent: () =>
      import('./features/not-found/pages/not-found-page/not-found-page.component')
        .then(m => m.NotFoundPageComponent),
    title: 'ページが見つかりません',
  },
  {
    path: '**',
    redirectTo: 'not-found',
  },
];
